import axios from "axios";
import store from "../vuex";
import router from "../router";
var platform = require('platform');
const HTTP_METHOD = {
  get: "get",
  post: "post",
  delete: "delete",
  put: "put",
};

const baseURL =
  window.configs && window.configs.VUE_APP_ROUTE_BASE_URL !== ""
    ? window.configs.VUE_APP_ROUTE_BASE_URL
    : process.env.VUE_APP_ROUTE_BASE_URL
    ? process.env.VUE_APP_ROUTE_BASE_URL
    : "https://nagora.recette.aws.vita.ovh";

const instance = axios.create({
  baseURL: baseURL,
});

function refreshToken() {

  const data = {
    versions: store.getters['appVersion'],
    os: platform.description.split('on')[0]
  }
  return instance.post("/api/adv/auth/renew", data);
}

instance.setToken = (token) => {
  instance.defaults.headers["Authorization"] = "Bearer " + token;
  localStorage.setItem("token", token);
};

instance.interceptors.request.use(
  function(config) {
    const token = localStorage.getItem("token");
    if (token && !config.headers.Authorization)  {
      config.headers.Authorization = "Bearer " + token;
    }
    if (!config.url.includes('auth/check')) {
      if(config.params && !config.params.isBackground || !config.params)  {
        store.dispatch("SET_LOADING", true);

      }
    
   
  }
  return config;
 },
  function(error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function(response) {
    store.dispatch("SET_LOADING", false);
    if (response.data.success) {
      store.dispatch("SET_SUCCESS_MESSAGE", response.data.message);
    } else {
      response.data.message &&
        store.dispatch("SET_ERROR_MESSAGE", response.data.message);
      response.status !== 204 && renewToken(response);
    }
    return response;
  },
  function(error) {
    store.dispatch("SET_ERROR_MESSAGE", error);
    store.dispatch("SET_LOADING", false);
    if (error.response.status == 401) {
      renewToken(error.response);
    }
    return Promise.reject(error);
  }
);

const processHttp = ({ method, url, data, config }) => {
  return instance({
    method: method,
    url: url,
    data: data,
    ...config,
  })
    .then((res) => {
      return res.data;
    })
    .finally(() => {
      store.dispatch("SET_LOADING", false);
    });
};

const httpClient = {
  get: (url, config) => processHttp({ method: HTTP_METHOD.get, url, config }),
  post: (url, data, config) =>
    processHttp({ method: HTTP_METHOD.post, url, data, config }),
  put: (url, data, config) =>
    processHttp({ method: HTTP_METHOD.put, url, data, config }),
  delete: (url, data, config) =>
    processHttp({ method: HTTP_METHOD.delete, url, data, config }),
  buildParams(object) {
    let res = "";
    if (typeof object === "object") {
      for (let k in object) {
        let val = object[k];
        if (val === undefined || val === null) {
          val = "";
        }
        if (Array.isArray(val)) {
          val = val.join(",");
        }
        res += `${k}=${val}&`;
      }
    }
    return res;
  },
};

const renewToken = (response) => {
  const existToken = localStorage.getItem("token") ? localStorage.getItem("token") : undefined;
  if(existToken) {
    
     if(!response.config.url.includes('auth/check')) {
       if(!response.data) {
        store.dispatch('auth/DISCONNECT')

       } else {
        const currentDate = Math.floor(Date.now() / 1000);
        const expireTime = parseJwt(existToken)
        ? parseJwt(existToken).exp
        : undefined;
        if((expireTime  && expireTime <currentDate && response.status =='401') || (response.data && response.data.message && response.status =='401')) {
          store.dispatch('auth/DISCONNECT')
        }
       }
     }
  
   
  }
};

const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));


  return JSON.parse(jsonPayload);
}

export default httpClient;
